import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Banner } from '@deckplan.io/common';
import { BannerService } from '../banner.service';
import { AuthService } from '../../auth/auth.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-banner-bar',
    templateUrl: './banner-bar.component.html',
    styleUrls: ['./banner-bar.component.scss']
})
export class BannerBarComponent implements OnInit {

    @Output() public bannersRetrievedCount = new EventEmitter<number>();

    public banners: Banner[] = [];

    constructor(private readonly bannerService: BannerService, private readonly authService: AuthService, private readonly sanitizer: DomSanitizer) {}

    public ngOnInit(): void {
        this.bannerService.getActiveForUser(this.authService.currentUserValue.id).subscribe(banners => {
            this.banners = banners;
            this.bannersRetrievedCount.emit(banners.length);
        });
    }

    public sanitizeBannerHtml(bannerMessage: string) {
        return this.sanitizer.bypassSecurityTrustHtml(bannerMessage);
    }
}
